<template>
  <div
    class="panel"
    :class="{'active': isActive}"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Tab',

  props: {
    hasWarning: {
      default: false,
      type: Boolean,
    },

    title: {
      type: String,
      required: true,
    },

    warningClass: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      isActive: false,
    };
  },
}
</script>
